import MobileNav from '../_plugins/mobileNavPlugin';

const menuHolder = document.querySelector('html');
const mobileNav = new MobileNav(menuHolder, {
	activeClass: 'nav-active',
	btnOpenerSelector: '.nav-opener',
	hideOnClickOutside: true,
	outSideSelector: '.main-nav-drop',
});

export default function initMobileNav() {
	mobileNav.init();
}







// WEBPACK FOOTER //
// ./assets/scripts/js/_components/mobileBurger.js